export enum ThemeE {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  MURALTO = 'Muralto',
}
